export interface DashboardConfig {
    name: string;
    title: string;
    showRegions: boolean;
    showIntervals: boolean;
    tabs: DashboardTab[];
}

export interface DashboardTab {
    name: string;
    title: string;
    rows: DashboardRow[];
}

export interface DashboardRow {
    height: number;
    columns: DashboardColumn[];
}

export interface DashboardColumn {
    title?: string;
    width?: number;
    content?: DashboardColumnContent;
    rows?: DashboardRow[];
}

export interface DashboardColumnContent {
    type: number;  // 0 = Widget, 1 = Dashboard (nested, not yet supported)
    ref: string;   // Widget name (key in widgets map)
    params?: { [key: string]: any };
}

export enum WidgetType {
    ChartBar = 0,
    ChartLine = 1,
    ChartArea = 2,
    ChartPie = 3,
    ChartCard = 4,
    Actions = 5
}

export interface ChartConfig {
    legend: boolean;
    showLabels: boolean;
    animations: boolean;
    gradient: boolean;
    xAxis: boolean;
    yAxis: boolean;
    showYAxisLabel: boolean;
    showXAxisLabel: boolean;
    xAxisLabel: string;
    yAxisLabel: string;
    timeline: boolean;
    cardColor?: string;
}

export interface DashboardWidget {
    type: WidgetType;
    label?: string;
    dataSource?: DashboardWidgetDataSource;
    chartConfig?: ChartConfig;
    actions?: string[];
    data?: any | null;
    // Internal field set during initialization – not present in API response
    name?: string;
}

export interface DashboardWidgetDataSource {
    name: string;
    params?: { [key: string]: any };
}

export interface DashboardChartPoint {
    name: string;
    value: number;
}

export interface DashboardCardPoint extends DashboardChartPoint {
    extra?: {
        change?: number;
        changeLabel?: string;
        unit?: string;
    };
}
